/* IARA theme - storefront behaviour. No dependencies, no third-party requests. */
(function () {
  'use strict';

  var config = {};
  try {
    config = JSON.parse(document.getElementById('IaraConfig').textContent);
  } catch (e) {
    config = { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', predictiveSearch: '/search/suggest' }, strings: {}, cartType: 'page' };
  }
  var strings = config.strings || {};

  /* ---------- Helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () { var args = arguments, ctx = this; clearTimeout(t); t = setTimeout(function () { fn.apply(ctx, args); }, wait); };
  }
  function parseHTML(text) { return new DOMParser().parseFromString(text, 'text/html'); }
  function toast(message) {
    var el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }
  function fetchJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) { throw new Error(data.description || data.message || strings.error); }
        return data;
      });
    });
  }

  /* ---------- Dialogs (menu, search, filters, size guide, cart) ---------- */
  var lastTrigger = null;
  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    lastTrigger = trigger || document.activeElement;
    if (typeof dialog.showModal === 'function') { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
    document.documentElement.style.overflow = 'hidden';
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var focusTarget = $('input[type="search"]', dialog) || $('[data-close]', dialog);
    if (focusTarget) focusTarget.focus();
  }
  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') { dialog.close(); } else { dialog.removeAttribute('open'); }
  }
  document.addEventListener('close', function (e) {
    if (e.target.tagName !== 'DIALOG') return;
    if (!$('dialog[open]')) document.documentElement.style.overflow = '';
    $$('[aria-controls="' + e.target.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }, true);

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openDialog(document.getElementById(opener.getAttribute('data-open')), opener); return; }
    var closer = e.target.closest('[data-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    // Click on the backdrop closes the dialog
    if (e.target.tagName === 'DIALOG' && e.target.open) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(e.target);
    }
  });

  /* ---------- Header: desktop dropdowns close on outside click / Esc ---------- */
  document.addEventListener('click', function (e) {
    $$('[data-dropdown][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-dropdown][open]').forEach(function (d) { d.removeAttribute('open'); $('summary', d).focus(); });
  });
  $$('[data-dropdown]').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) $$('[data-dropdown][open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    });
  });

  /* ---------- Announcement rotator ---------- */
  $$('[data-rotator]').forEach(function (track) {
    var items = $$('.announcement__item', track);
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 5000);
  });

  /* ---------- Footer columns collapse on mobile ---------- */
  var footerMq = window.matchMedia('(max-width: 989px)');
  function syncFooter() { $$('[data-footer-collapsible]').forEach(function (d) { d.open = !footerMq.matches; }); }
  syncFooter();
  if (footerMq.addEventListener) footerMq.addEventListener('change', syncFooter);

  /* ---------- Predictive search ---------- */
  var searchForm = $('[data-predictive-search="true"]');
  if (searchForm) {
    var input = $('input[name="q"]', searchForm);
    var results = $('[data-predictive-results]');
    var controller = null;
    input.addEventListener('input', debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = config.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search';
      fetch(url, { signal: controller ? controller.signal : undefined, credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error(); return res.text(); })
        .then(function (text) {
          var doc = parseHTML(text);
          var content = $('.predictive', doc);
          results.innerHTML = '';
          if (content) results.appendChild(document.importNode(content, true));
        })
        .catch(function () {});
    }, 250));
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity] button');
    if (!btn) return;
    var field = $('input', btn.closest('[data-quantity]'));
    var min = parseInt(field.min || '0', 10);
    var max = parseInt(field.max || '99', 10);
    var value = parseInt(field.value || '0', 10) + (btn.name === 'plus' ? 1 : -1);
    field.value = Math.max(min, Math.min(max, value));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  function cartSectionIds() {
    var ids = [];
    $$('[data-cart-root]').forEach(function (root) {
      var id = root.getAttribute('data-section-id') || root.closest('.shopify-section').id.replace('shopify-section-', '');
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }
  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      if (!sections[id]) return;
      var doc = parseHTML(sections[id]);
      var fresh = $('[data-cart-root]', doc);
      var current = $('[data-cart-root][data-section-id="' + id + '"]');
      if (!fresh || !current) return;
      if (current.tagName === 'DIALOG') {
        // Keep the dialog element (and its open state); swap only its contents.
        current.innerHTML = fresh.innerHTML;
      } else {
        current.replaceWith(fresh);
      }
    });
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.hidden = count === 0;
      var visible = el.querySelector('[aria-hidden]');
      if (visible) visible.textContent = count;
    });
  }
  function refreshCount() {
    fetch(config.routes.cart + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); })
      .catch(function () {});
  }
  function changeLine(line, quantity) {
    var roots = $$('[data-cart-root]');
    roots.forEach(function (r) { r.classList.add('is-busy'); });
    fetchJSON(config.routes.cartChange + '.js', { line: line, quantity: quantity, sections: cartSectionIds().join(','), sections_url: window.location.pathname })
      .then(function (cart) { renderCartSections(cart.sections); updateCount(cart.item_count); })
      .catch(function (err) { toast(err.message || strings.error); })
      .then(function () { $$('[data-cart-root]').forEach(function (r) { r.classList.remove('is-busy'); }); });
  }
  document.addEventListener('change', debounce(function (e) {
    var qty = e.target.closest && e.target.closest('[data-line-qty]');
    if (qty) changeLine(parseInt(qty.getAttribute('data-line-qty'), 10), parseInt(qty.value || '0', 10));
  }, 350));
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(parseInt(remove.getAttribute('data-line-remove'), 10), 0);
  });
  document.addEventListener('change', debounce(function (e) {
    if (!e.target.matches || !e.target.matches('[data-cart-note]')) return;
    fetchJSON(config.routes.cart + '/update.js', { note: e.target.value }).catch(function () {});
  }, 500));

  // Open the side bag from the header icon instead of navigating
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    var drawer = document.getElementById('CartDrawer');
    if (!toggle || !drawer) return;
    e.preventDefault();
    openDialog(drawer, toggle);
  });

  /* ---------- Product page ---------- */
  /* ---------- Product gallery: thumbnails, arrows, hover zoom, viewer ---------- */
  function initGallery(section, list) {
    if (!list) return null;
    var items = $$('.product__media-item', list);
    var thumbs = $$('[data-thumb]', section);
    var counter = $('[data-gallery-current]', section);
    var current = 0;
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
      var activeThumb = thumbs[i];
      if (activeThumb && activeThumb.parentElement && activeThumb.parentElement.parentElement) {
        var strip = activeThumb.parentElement.parentElement;
        var li = activeThumb.parentElement;
        if (strip.scrollHeight > strip.clientHeight) strip.scrollTo({ top: li.offsetTop - strip.clientHeight / 2 + li.clientHeight / 2, behavior: 'smooth' });
        if (strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: li.offsetLeft - strip.clientWidth / 2 + li.clientWidth / 2, behavior: 'smooth' });
      }
      if (counter) counter.textContent = i + 1;
    }
    function goTo(i) {
      if (!items.length) return;
      i = Math.max(0, Math.min(items.length - 1, i));
      list.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    list.addEventListener('scroll', debounce(function () {
      var i = Math.round(list.scrollLeft / list.clientWidth);
      if (i !== current) setActive(i);
    }, 60), { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    var prev = $('[data-gallery-prev]', section), next = $('[data-gallery-next]', section);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    list.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    var start = items.findIndex ? items.findIndex(function (el) { return el.hasAttribute('data-active'); }) : -1;
    if (start > 0) { list.scrollLeft = items[start].offsetLeft; setActive(start); }

    // Hover zoom (desktop pointers only): the image follows the cursor at 2x
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      $$('[data-hover-zoom]', section).forEach(function (btn) {
        var img = $('img', btn);
        if (!img) return;
        btn.addEventListener('mousemove', function (e) {
          var r = btn.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          btn.classList.add('is-zooming');
        });
        btn.addEventListener('mouseleave', function () { btn.classList.remove('is-zooming'); });
      });
    }

    // Full-screen viewer with click / tap / pinch zoom
    var lightbox = $('[data-lightbox]');
    if (lightbox) {
      var track = $('[data-lightbox-track]', lightbox);
      var slides = $$('.lightbox__item', track);
      var lbIndex = 0;
      var lbGo = function (k) {
        k = Math.max(0, Math.min(slides.length - 1, k));
        lbIndex = k; unzoom();
        track.scrollTo({ left: slides[k].offsetLeft, behavior: 'smooth' });
      };
      var unzoom = function () {
        lightbox.classList.remove('is-zoomed');
        slides.forEach(function (s) { s.classList.remove('is-zoomed'); s.scrollTop = 0; s.scrollLeft = 0; });
      };
      section.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-lightbox-open]');
        if (!opener) return;
        var media = parseInt(opener.getAttribute('data-lightbox-open'), 10);
        openDialog(lightbox, opener);
        var k = 0;
        slides.some(function (s, n) { if (parseInt(s.getAttribute('data-index'), 10) === media) { k = n; return true; } return false; });
        lbIndex = k; unzoom();
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = slides[k] ? slides[k].offsetLeft : 0;
        requestAnimationFrame(function () { track.style.scrollBehavior = ''; });
      });
      track.addEventListener('scroll', debounce(function () { if (!lightbox.classList.contains('is-zoomed')) lbIndex = Math.round(track.scrollLeft / track.clientWidth); }, 80), { passive: true });
      var lp = $('[data-lightbox-prev]', lightbox), ln = $('[data-lightbox-next]', lightbox);
      if (lp) lp.addEventListener('click', function () { lbGo(lbIndex - 1); });
      if (ln) ln.addEventListener('click', function () { lbGo(lbIndex + 1); });
      lightbox.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') lbGo(lbIndex + 1);
        if (e.key === 'ArrowLeft') lbGo(lbIndex - 1);
      });
      slides.forEach(function (slide) {
        var img = $('img', slide);
        if (!img) return;
        img.addEventListener('click', function (e) {
          var zoomed = slide.classList.toggle('is-zoomed');
          lightbox.classList.toggle('is-zoomed', zoomed);
          if (!zoomed) { slide.scrollTop = 0; slide.scrollLeft = 0; return; }
          var r = img.getBoundingClientRect();
          var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
          requestAnimationFrame(function () {
            slide.scrollLeft = fx * img.offsetWidth - slide.clientWidth / 2;
            slide.scrollTop = fy * img.offsetHeight - slide.clientHeight / 2;
          });
        });
      });
      lightbox.addEventListener('close', unzoom);
    }
    return { goTo: goTo };
  }

  function initProduct(section) {
    var sectionId = section.getAttribute('data-section-id');
    var productUrl = section.getAttribute('data-product-url');
    var variantJson = $('[data-variant-json]', section);
    var variants = variantJson ? JSON.parse(variantJson.textContent) : [];
    var mediaList = $('[data-media-list]', section);

    var gallery = initGallery(section, mediaList);

    // 3D models
    if ($('[data-model]', section) && window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0' }, { name: 'shopify-xr', version: '1.0' }], function () {});
    }

    // Variant selection
    var picker = $('.product__variants', section);
    if (picker && variants.length) {
      picker.addEventListener('change', function () {
        var selected = $$('fieldset', picker).map(function (fs) {
          var checked = $('input:checked', fs);
          var label = $('[data-option-selected]', fs);
          if (checked && label) label.textContent = checked.value;
          return checked ? checked.value : null;
        });
        var variant = variants.filter(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        })[0];
        markUnavailable(picker, variants, selected);
        var addBtn = $('[data-add-button]', section);
        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addBtn.querySelector('span').textContent = strings.unavailable; }
          return;
        }
        $$('[data-variant-id]', section).forEach(function (i) { i.value = variant.id; });
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (variant.media && mediaList && gallery) {
          var item = $('[data-media-id="' + variant.media + '"]', mediaList);
          if (item) gallery.goTo(parseInt(item.getAttribute('data-index'), 10));
        }
        refreshVariantBlocks(sectionId, productUrl, variant.id, section);
      });
      markUnavailable(picker, variants, $$('fieldset', picker).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }));
    }

    // Add to bag
    section.addEventListener('submit', function (e) {
      var form = e.target.closest('.product-form');
      if (!form || config.cartType !== 'drawer' || !document.getElementById('CartDrawer')) return;
      e.preventDefault();
      submitProductForm(form);
    });

    // Sticky add-to-bag bar on mobile
    var sticky = $('[data-sticky-buy]');
    var buy = $('[data-add-button]', section);
    if (sticky && buy && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var rect = entries[0].boundingClientRect;
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && rect.top < 0);
      }).observe(buy);
    }
  }

  function markUnavailable(picker, variants, selected) {
    $$('fieldset', picker).forEach(function (fs, optionIndex) {
      $$('input', fs).forEach(function (input) {
        var candidate = selected.slice();
        candidate[optionIndex] = input.value;
        var exists = variants.some(function (v) {
          return v.available && v.options.every(function (opt, i) { return opt === candidate[i]; });
        });
        input.classList.toggle('is-unavailable', !exists);
      });
    });
  }

  function refreshVariantBlocks(sectionId, productUrl, variantId, section) {
    fetch(productUrl + '?variant=' + variantId + '&section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = parseHTML(text);
        $$('[data-swap]', doc).forEach(function (fresh) {
          var current = document.getElementById(fresh.id);
          if (current) current.innerHTML = fresh.innerHTML;
        });
        var freshSticky = $('.sticky-buy .button', doc);
        var currentSticky = $('.sticky-buy .button');
        if (freshSticky && currentSticky) currentSticky.disabled = freshSticky.disabled;
        if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
      })
      .catch(function () {});
  }

  function submitProductForm(form) {
    var button = $('[data-add-button]', form);
    var error = $('[data-form-error]', form);
    if (button.disabled) return;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;
    var formData = new FormData(form);
    formData.append('sections', cartSectionIds().join(','));
    formData.append('sections_url', window.location.pathname);
    fetch(config.routes.cartAdd + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) { return res.json().then(function (data) { if (!res.ok || data.status) throw new Error(data.description || data.message); return data; }); })
      .then(function (data) {
        renderCartSections(data.sections);
        refreshCount();
        openDialog(document.getElementById('CartDrawer'), button);
      })
      .catch(function (err) {
        if (error) { error.textContent = err.message || strings.error; error.hidden = false; }
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  }

  $$('[data-product]').forEach(initProduct);

  /* ---------- Share (native share sheet, or copy link) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    var url = btn.getAttribute('data-share-url');
    var title = btn.getAttribute('data-share-title');
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast(btn.getAttribute('data-copied')); });
    }
  });

  /* ---------- Related products (loaded after the page) ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var load = function () {
      fetch(el.getAttribute('data-url'), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var fresh = $('[data-recommendations]', parseHTML(text));
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            $$('[data-carousel]', el).forEach(initCarousel);
            initImageFade(el);
          }
        })
        .catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else { load(); }
  });

  /* ---------- Shopify Markets locale: apply selection immediately ---------- */
  function initLanguageForms(scope) {
    $$('[data-language-auto-submit]', scope).forEach(function (select) {
      if (select.dataset.iaraBound) return;
      select.dataset.iaraBound = '1';
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (!form) return;
        select.disabled = false;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    });
  }
  initLanguageForms(document);

  /* ---------- Carousels: swipe/scroll native, optional overlay arrows ---------- */
  function initCarousel(root) {
    var track = $('[data-carousel-track]', root);
    var prev = $('[data-carousel-prev]', root);
    var next = $('[data-carousel-next]', root);
    if (!track || !prev || !next || root._carousel) return;
    root._carousel = true;
    function update() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      var media = $('.card__media', track);
      if (media) {
        var a = media.getBoundingClientRect();
        var b = root.getBoundingClientRect();
        root.style.setProperty('--carousel-arrow-y', (a.top - b.top + a.height / 2) + 'px');
      }
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      root.classList.toggle('carousel--static', max <= 0);
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    track.addEventListener('scroll', debounce(update, 60), { passive: true });
    window.addEventListener('resize', debounce(update, 150));
    update();
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ---------- Collection: sort and filter auto-apply ---------- */
  $$('[data-filter-form]').forEach(function (form) {
    $$('[data-auto-submit]', form).forEach(function (s) {
      s.addEventListener('change', function () { form.submit(); });
    });
  });

  /* ---------- Confirm before destructive account actions ---------- */
  document.addEventListener('submit', function (e) {
    var btn = e.submitter || $('[data-confirm]', e.target);
    if (btn && btn.hasAttribute && btn.hasAttribute('data-confirm') && !window.confirm(btn.getAttribute('data-confirm'))) e.preventDefault();
  });

  /* ---------- Address forms: preselect saved country ---------- */
  $$('select[data-default]').forEach(function (s) {
    var v = s.getAttribute('data-default');
    if (v) s.value = v;
  });

  /* ---------- Soft reveal on scroll (opacity/transform only) ---------- */
  function initReveal(root) {
    var items = $$('[data-reveal]:not(.is-revealed)', root);
    if (!items.length) return;
    if (!document.body.classList.contains('has-reveal') || !('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 10% 0px', threshold: 0 });
    items.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 4, 3) * 90 + 'ms';
      io.observe(el);
    });
  }
  initReveal(document);

  /* ---------- Images fade in once loaded ---------- */
  var FADE_SELECTOR = '.card__img:not(.card__img--second), .tile__media img, .product__img, .campaign__img, .hero__img, .split__media img, .banner__media img, .collection__image img, .category__media img';
  function initImageFade(root) {
    $$(FADE_SELECTOR, root).forEach(function (img) {
      if (img.classList.contains('is-loaded')) return;
      var done = function () { img.classList.add('is-loaded'); };
      if (img.complete && img.naturalWidth > 0) { done(); return; }
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }
  initImageFade(document);

  /* ---------- Header refines after scrolling ---------- */
  var headerEl = $('[data-header]');
  if (headerEl) {
    var onScroll = function () { headerEl.classList.toggle('is-scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Soft fade between pages ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', function (e) {
    if (reduceMotion || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
    var url = new URL(a.href, window.location.href);
    if (url.origin !== window.location.origin || (url.pathname === window.location.pathname && url.hash)) return;
    if (/^(mailto|tel):/.test(a.getAttribute('href'))) return;
    e.preventDefault();
    document.body.classList.add('is-leaving');
    setTimeout(function () { window.location.href = url.href; }, 260);
  });
  window.addEventListener('pageshow', function () { document.body.classList.remove('is-leaving'); });
  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product]', e.target).forEach(initProduct);
    $$('[data-carousel]', e.target).forEach(initCarousel);
    initLanguageForms(e.target);
    $$('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-revealed'); });
    initImageFade(e.target);
  });
})();
